import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, Subscription, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';

import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '../shared/services/authentication.service';
import Swal from 'sweetalert2';
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  lang = localStorage.getItem('language') || 'en';
  subscriptions: Subscription[] = [];

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry({ count: 4, delay: 10000 }),
      catchError(err => {
        if (err.status === 425) {
          this.authenticationService.logout();
        }
        if (this.authenticationService.currentUserValue) {
          if (err.status === 424 || err.status === 423 || err.status === 403) {
            // this.authenticationService.logout();
            this.router.navigate(['/notAuthorized']);
            setTimeout(() => { Swal.close() }, 100);
          }
          if (err.status === 401 || err.status === 422) {
            Swal.fire({
              title: 'Your session has been expired!',
              // html: `<h2 class="swal2-title m-0">Getting your data ...</h2><h2 class="swal2-title m-0">Please stay on this page</h2>`,
              icon: 'warning',
              showLoaderOnConfirm: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              // didOpen: () => Swal.showLoading(),
              showCancelButton: true,
              confirmButtonText: 'Login',
              cancelButtonText: 'Logout',
              preConfirm: () => {
                Swal.showLoading();
                return new Promise((resolve, reject) => {
                  this.authenticationService.RefeshUserToken().subscribe({
                    next: (data) => {
                      resolve(data);
                    },
                    error: (err) => {
                      Swal.hideLoading();
                      Swal.showValidationMessage(
                        err?.message || 'Failed to refresh token'
                      );
                      reject(err);
                    }
                  })
                });
              },
            }).then(result => {
              if (result && result.dismiss) {
                this.authenticationService.logout();
              }
            })
            // if (!this.subscriptions.length) {
            //   this.subscriptions.push(
            //     this.authenticationService.RefeshUserToken().subscribe(data => {
            //       this.subscriptions = [];
            //       Swal.close();
            //     }, err => {
            //       this.authenticationService.logout();
            //       Swal.close();
            //       this.subscriptions = [];
            //     })
            //   );
            // }
          }
        }
        if (err.status === 0) { // Offline
          this.snackBar.open(
            this.lang == 'en' ? 'You are offline!' : 'أنت غير متصل!',
            this.lang == 'en' ? 'Ok' : 'حسنا',
            {
              horizontalPosition: 'center',
              verticalPosition: 'top'
            });
          // this.snackBar.open(this.translate.instant('general.You are offline!'), this.translate.instant('swalMsg.Ok'), {
          //   horizontalPosition: 'center',
          //   verticalPosition: 'top'
          // });
        }

        // const error = err.error.message || err.statusText;
        return throwError(err.error);
      })
    );
  }
}
